import React from 'react';
import { Tooltip } from '@mui/material';
import { t } from 'i18next';

interface ExternalEmailMarkerProps {
    email?: string;
    internalFromEmail?: string;
    internalDomain?: string;
}

const getInternalDomainFromEmail = (email?: string): string | undefined => {
    if (email && email.includes('@')) {
        const domain = email.split('@')[1]?.toLowerCase();
        if (domain) {
            // Check if it's a valid domain (contains at least one dot and follows domain naming conventions)
            const isValidDomain = domain.includes('.') && 
                /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(domain);
            
            // Only return domain if it's a valid domain format
            return isValidDomain ? `@${domain}` : undefined;
        }
    }
    return undefined;
};

export const ExternalEmailMarker: React.FC<ExternalEmailMarkerProps> = (props: ExternalEmailMarkerProps) => {
    const { email, internalFromEmail, internalDomain } = props;
    const resolvedDomain = internalDomain || getInternalDomainFromEmail(internalFromEmail);
    
    // Only show external marker if both email and resolved domain are valid domains
    const emailDomain = getInternalDomainFromEmail(email);
    const isExternal = !!email && !!resolvedDomain && !!emailDomain && !email.toLowerCase().endsWith(resolvedDomain);

    if (!isExternal) {
        return null;
    }

    return (
        <Tooltip title={t('item.external')}>
            <span 
                style={{
                    backgroundColor: '#FFF59D',
                    color: '#000',
                    borderRadius: 4,
                    padding: '0 6px',
                    fontWeight: 700,
                    lineHeight: 1.2,
                    cursor: 'pointer',
                    display: 'inline-block',
                    transition: 'background-color 0.2s ease',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#FFE082';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#FFF59D';
                }}
            >
                E
            </span>
        </Tooltip>
    );
};

export default ExternalEmailMarker;


